module.exports = __webpack_public_path__ + "media/images/product-img-05-59cf770d64362f4a5a9d1b6fddcff7cd.png";